<!-- Plantas.vue -->
<template>
    <div class="g-data_set_class w-full gap-2 p-4 flex flex-col text-[var(--text)]">
        <div class="w-full flex justify-between">
            <h3 class="text-[var(--titulo)]">Documentos do Utilizador</h3>
            <AppButton class="self-end text-[var(--icon)]" v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl"
                emitType="close" @close="close" :width="23" :height="23" />
        </div>

        <!-- Formulário de Adicionar Planta -->
        <form @submit.prevent="uploadDocumento"
            class="flex flex-col items-left gap-2 outline-none focus:ring-2 focus:ring-[var(--button)] p-2 w-full">

            <FormSelect v-model="tipo" id="tipo" label="Tipo:" :options="tipos"
                    placeholder="Seleciona o Tipo de Documento" required class="rounded-md p-1" />

            <div class="w-full grid grid-cols-2 items-center gap-1">


                <label for="nome" class="text-[var(--label)]">Nome:</label>
                <input v-model="documento.nome" id="nome" placeholder="Nome do Documento" required class="rounded-md p-1" />
            </div>

            <div class="w-full grid grid-cols-2 items-center gap-1">
                <label for="imagem" class="text-[var(--label)]">Documento:</label>
                <input type="file" @change="handleFileUpload" required class="rounded-md p-1" />
            </div>

            <div class="flex justify-end gap-2 mt-2">
                <button type="submit" class="btn btn-info flex items-center gap-2">
                    <i class="fa-solid fa-upload"></i>
                    Carregar Documento
                </button>

            </div>
        </form>

        <!-- Alternar entre Lista e Lista de Imagens -->
        <div class="mt-4 flex justify-end">
            <button @click="toggleViewMode" class="btn btn-info flex items-center gap-2">
                <i class="fa-solid" :class="viewMode !== 'list' ? 'fa-images' : 'fa-list'"></i>
                {{ viewMode !== 'list' ? 'Ver como Imagens' : 'Ver como Lista' }}
            </button>
        </div>

        <!-- Lista de Plantas -->
        <div v-if="showDocumentoList" class="mt-4 p-2 rounded-2xl bg-[var(--fundoComponente)] border border-[var(--glass-border)] flex-1 overflow-y-auto w-full">
            <div v-if="documentos.length > 0">
                <div v-if="viewMode !== 'list'">
                    <!-- Visualização em Lista -->
                    <AppTable :visibility="true" :show="true" :table_data="documentos" table_title="Documentos Salvos"
                        @row-clicked="selectDocumento" @close="toggleDocumentList" :show_multiSelect="false" />
                </div>
                <div v-else>
                    <!-- Visualização em Imagens -->
                    <div class="flex overflow-x-auto gap-4 p-2 flex-wrap">
                        <div v-for="documento in documentos" :key="documento.id"
                            class="flex flex-col items-center gap-2 group cursor-pointer flex-none w-1/5 max-w-[20%]"
                            @mouseover="hover = documento.id" @mouseleave="hover = null" @click="selectDocumento(documento)">
                        <!-- Show image preview for image files -->
                        <img v-if="isImage(documento.documento)"
                            :src="getDocumentUrl(documento)"
                            :alt="`Imagem de ${documento.nome}`"
                            @error="handleImageError($event, documento)"
                            class="w-20 h-20 rounded-full object-cover transition-transform duration-300 group-hover:scale-110 shadow-lg"
                        />
                        
                        <!-- Show PDF icon for PDF files -->
                        <div v-else class="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center">
                            <i class="fas fa-file-pdf text-4xl text-red-500"></i>
                        </div>
                        <i class="text-center text-[var(--text)] group-hover:text-[var(--button)] transition-colors duration-300 not-italic">
                            {{ documento.nome }}
                        </i>
                        </div>
                    </div>
                    </div>
            </div>
            <div v-else class="text-center no-documents-message">
                Nenhum Documento Encontrado.
            </div>
        </div>

        <!-- Modal para Visualização da Imagem -->
        <div v-if="selectedDocumento" class="popup-overlay fixed inset-0 flex items-center justify-center z-50">
            <div class="popup-content p-4 rounded-md max-w-4xl max-h-[90vh] overflow-auto">
                <div class="flex justify-between items-center mb-2">
                    <h2 class="text-lg font-bold text-[var(--titulo)]">{{ selectedDocumento.nome }}</h2>
                    <AppButton style="color: var(--icon);" v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl"
                        emitType="close" @close="closeModal" :width="20" :height="20" />
                </div>
                <div class="relative">
                    <!-- MS estava plantas/imagem parece me que as classes soa iguais, mas a plantas/foto usa dirPlanta
             Nao percebo o conceito de coordenadas aqui-->
                    <!-- Este modal é só para imagens: PDFs abrem diretamente numa nova
                         aba (ver selectDocumento), nunca chegam a definir selectedDocumento. -->
                    <img :src="getDocumentUrl(selectedDocumento)" alt="Imagem do Documento"
                        @error="handleImageError($event, selectedDocumento)"
                        class="max-w-full max-h-[70vh] w-auto h-auto object-contain"  />
                </div>
                <div class="flex justify-center mt-4">
                    <button @click="closeModal" class="btn btn-danger px-4 py-2">
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    </div>
    

</template>
  
  <script>
  import axios from "axios";
  import AppTable from "@/components/tables/table.vue";
  import { toast } from "vue3-toastify";
  import AppButton from "@/components/updated/button.vue";
  import FormSelect from "@/components/FormSelect.vue";
  export default {
    name: "Documentos",
    components: {
      AppTable,
      AppButton,
      FormSelect,
    },
    props: {
      utilizadorId: {
        type: Number,
        required: true,
      },
    },
    mounted() {
    //this.fetchPlants();
  },
    data() {
      return {
        documento: {
          nome: "",
          imagem: null,
        },
        documentos: [],
        showDocumentoList: true,
        selectedDocumento: null,
        viewMode: "list",
        coordinates: null,
        baseURL: process.env.VUE_APP_URL_BASE,
        tipos: [],
        tipo: "",
      };
    },
    methods: {
  
      handleFileUpload(event) {
        this.documento.imagem = event.target.files[0];
      },
      async uploadDocumento() {
        console.log("Uploading document:", this.documento);
        if (!this.documento.nome || !this.documento.imagem || this.tipo === "") {
          toast.error("Por favor, preencha todos os campos.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          return;
        }
        console.log("tipo", this.tipo);
         

        const formData = new FormData();
        formData.append("nome", this.documento.nome);
        formData.append("utilizador_id", this.utilizadorId);
        formData.append("tpDocumento_id", this.tipo);
        formData.append("documento", this.documento.imagem);

        const res = await axios.post(`${this.baseURL}/api/v1/documentoutilizador/upload/`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        console.log("res", res);
        if (res.status === 201) {
          toast.success("Documento carregado com sucesso!", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          this.resetForm();
          this.getDocumentos();
        } else {
          toast.error("Erro ao carregar o documento. Tente novamente.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
        }
        
  
        
      },  
    
      toggleDocumentList() {
        this.showDocumentoList = !this.showDocumentoList;
        if (this.showDocumentoList) {
          this.getDocumentos();
        } 
      },
      toggleViewMode() {
        this.viewMode = this.viewMode === "list" ? "image" : "list";
      },
      async selectDocumento(plant) {
        if (!this.isImage(plant.documento)) {
          // PDFs: abrir diretamente numa nova aba do browser em vez do modal.
          // O PdfPreviewDialog, aninhado dentro deste popup, tinha o seu
          // próprio overlay position:fixed em conflito com o popup-overlay
          // exterior (o browser cria um novo containing block para
          // position:fixed sempre que um antecessor usa transform/filter,
          // o que aqui reduzia o "ecrã inteiro" do PDF ao tamanho do popup).
          // Abrir numa aba usa o leitor de PDF nativo do browser, que
          // preenche a aba corretamente. blobUrl já foi obtido com os
          // headers de auth/schema corretos em loadDocumentBlob().
          if (!plant.blobUrl) {
            await this.loadDocumentBlob(plant);
          }
          if (plant.blobUrl) {
            window.open(plant.blobUrl, "_blank");
          } else {
            toast.error("Não foi possível abrir o documento.");
          }
          return;
        }
        this.selectedDocumento = plant;
        this.coordinates = null;
      },
      closeModal() {
        this.selectedDocumento = null;
        this.coordinates = null;
      },
      resetForm() {
        this.documento.nome = "";
        this.documento.imagem = null;
      },
      close() {
        this.$emit("close");
      },
      async getTipos() {
        const res = await this.select(
          `${this.baseURL}/api/v1/tpdocumento/`
        );
        if (res) {
          this.tipos = res.map((tipo) => ({
            id: tipo.id,
            nome: tipo.nome,
          }));
        } else {
          console.error("Erro ao buscar tipos de documentos.");
        }
      },

      async getDocumentos() {
            const res = await this.select(
                `${this.baseURL}/api/v1/documentoutilizador/utilizador/${this.utilizadorId}/`
            );
            if (res) {
                this.documentos = res.map((doc) => ({
                    id: doc.id,
                    nome: doc.nome,
                    //diretoria: doc.diretoria,
                    tipo: doc.tipo,
                    documento: doc.documento,
                    utilizador_id: doc.utilizador_id,
                    status: doc.status,
                    blobUrl: null // Initialize blob URL
                }));

                // Load blob URLs for all documents (images and PDFs) em paralelo
                await Promise.all(this.documentos.map((doc) => this.loadDocumentBlob(doc)));
            } else {
                console.error("Erro ao buscar documentos.");
            }
        },

        async loadDocumentBlob(documento) {
            try {
                const response = await axios.get(`${this.baseURL}/api/v1/documentoutilizador/view/${documento.id}/`, {
                    responseType: 'blob'
                });
                if (response.status === 200) {
                    // response.data já é um Blob com o Content-Type correto (definido pelo
                    // servidor). Envolvê-lo em `new Blob([...])` sem indicar `type` perdia
                    // o MIME type (ficava ""), e sem tipo o browser recusa-se a renderizar
                    // a imagem/PDF a partir do blob: URL.
                    documento.blobUrl = URL.createObjectURL(response.data);
                }
            } catch (error) {
                console.error('Error loading document blob:', error);
            }
        },

        async select(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;
            } catch (error) {
                console.error("Error getting data:", error);
            }
        },

        isImage(filename) {
            if (!filename) return false;
            const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
            const lowerFilename = filename.toLowerCase();
            return imageExtensions.some(ext => lowerFilename.endsWith(ext));
        },
        
        getDocumentUrl(documento) {
            if (!documento.id) return '';

            // For images, use the blob URL if available
            if (this.isImage(documento.documento)) {
                return documento.blobUrl || '';
            }
            return '';
        },

        handleImageError(event, documento) {
            console.error("Error loading image:", documento.documento);
            // Fallback inline (sem depender de um asset externo): ícone neutro de "imagem indisponível"
            event.target.src = "data:image/svg+xml;utf8," + encodeURIComponent(
                '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80">' +
                '<rect width="80" height="80" fill="#e5e7eb"/>' +
                '<path d="M20 55 L32 40 L42 50 L55 32 L65 55 Z" fill="#9ca3af"/>' +
                '<circle cx="30" cy="28" r="6" fill="#9ca3af"/>' +
                '</svg>'
            );
            event.target.alt = 'Imagem não disponível';
        }
    },
    async created() {
        await this.getTipos();
        await this.getDocumentos();
      //this.fetchPlants();
    },
    watch: {
      utilizadorId: {
        immediate: true,
        handler(newVal) {
        
          this.getDocumentos();
        },
      },
    },
  };
  </script>
  
  <style scoped>
  input[type="file"],
  input[type="text"] {
    /* border-radius/border/background já vêm do tema global (.glass-app input) */
    padding: 0.5rem;
    font-size: 0.875rem;
  }
  .no-documents-message {
    text-align: center;
    color: var(--titulo);
    font-size: 0.875rem;
  }
  .fixed {
    position: fixed;
    z-index: 1000;
  }
  .bg-black {
    background-color: rgba(0, 0, 0, 0.5);
  }
  .coordinate-marker {
    position: absolute;
    transform: translate(-50%, -100%);
    color: red;
  }
  .relative {
    position: relative;
  }
  
  .flex::-webkit-scrollbar {
    height: 8px;
  }
  
  .flex::-webkit-scrollbar-thumb {
    background-color: rgba(93, 93, 152, 0.8);
    border-radius: 4px;
  }
  
  .flex::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  /* Ajustar o espaçamento entre as imagens */
  img {
    transition: transform 0.3s ease-in-out;
  }
  img:hover {
    transform: scale(1.1);
  }
  
  </style>
  